import React, { useEffect } from "react";
import "../styles/Client.css";
import maintenanceImage from "../assets/careers1A.avif";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Beams from "./Beams";
import Header from "./Header";
import Footer from "./Footer";

import logo1 from "../assets/careers2A.avif";
import logo2 from "../assets/careers3A.webp";
import logo3 from "../assets/careers4A.jpg";

const Careers = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    window.scrollTo(0, 0);
  }, []);

  // Function to open LinkedIn when Apply button is clicked
  const openLinkedIn = () => {
    window.open("https://www.linkedin.com/company/acume-gcc/posts/?feedView=all", "_blank");
  };

  return (
    <>
      <Header />

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="client-services-container">
        <div className="client-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00BFFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={61}
          />
        </div>

        <div className="client-services-left" data-aos="fade-right">
          <h1>Creating a Better Experience</h1>
          <p>
            At our core, we believe that people are the foundation of success.
            We’re always looking for passionate, creative, and driven individuals
            who are ready to make an impact.
          </p>
        </div>

        <div className="client-services-right" data-aos="fade-left">
          <img
            src={maintenanceImage}
            alt="Client Collaboration Visual"
            className="client-gif"
          />
        </div>
      </div>

      <div className="careers-center-section" data-aos="fade-up">
        <h2 className="careers-main-heading">Careers</h2>
        <p className="careers-subheading">
          Your skills for our thriving work environment
        </p>
      </div>

      <div className="careers-two-column" data-aos="fade-up">
        <div className="careers-box-left">
          <img src={logo1} alt="Career Visual 1" className="careers-box-image" />
          <p className="careers-box-text">
            Join our path and grow with international engineering standards.
          </p>
        </div>

        <div className="careers-box-right">
          <img src={logo2} alt="Career Visual 2" className="careers-box-image" />
          <p className="careers-box-text">
            Address technical challenges with ethical excellence.
          </p>
        </div>
      </div>

      <div className="careers-bottom-box" data-aos="fade-up">
        <img
          src={logo3}
          alt="Career Opportunities"
          className="careers-bottom-image"
        />
        <div className="careers-bottom-content">
          <h1>JOB OPENINGS</h1>
          <h3>Testing & Commissioning Engineers</h3>
          <p>• 3 to 8 years of Experience.</p>
          <h3>SCADA Substation Engineers</h3>
          <p>• 2 to 5 years of Experience.</p>
          <h3>Operation & Maintenance Engineers</h3>
          <p>• 2 to 5 years of Experience.</p>
        </div>
      </div>

      {/* ONLY APPLY BUTTON (NO FORM NOW) */}
      <div className="careers-apply-section" data-aos="fade-up">
        <button
          type="button"
          className="advanced-apply-btn"
          onClick={openLinkedIn}
        >
          Apply Now (LinkedIn)
          <span className="icon-wrap">
            <svg viewBox="0 0 16 19" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z" />
            </svg>
          </span>
        </button>
      </div>

      <Footer />
    </>
  );
};

export default Careers;
